export const LOCALSTORAGE_SHOPPING_CART_ID = 'shoppingCartId';
